import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiSearch, FiTool, FiDollarSign, FiMapPin, FiClock, FiCar, FiSettings, FiBell, FiRepeat } = FiIcons;

const QuickActions = ({ onActionClick }) => {
  const actions = [
    { icon: FiSearch, label: 'Search Inventory', action: 'Show me used trucks and SUVs' },
    { icon: FiDollarSign, label: 'Loan Calculator', action: 'Show me the loan calculator' },
    { icon: FiBell, label: 'Price Alerts', action: 'Tell me about price drops' },
    { icon: FiCar, label: 'Trade-In Value', action: 'What is my trade-in worth?' },
    { icon: FiRepeat, label: 'Compare Models', action: 'Compare inventory models' },
    { icon: FiSettings, label: 'Recommendations', action: 'Help me choose a car' },
    { icon: FiTool, label: 'Service & Maintenance', action: 'I need to book service' },
    { icon: FiMapPin, label: 'Hours & Location', action: 'Where is Carson Exports located?' },
    { icon: FiClock, label: 'Current Specials', action: 'What are your current deals?' }
  ];

  return (
    <div className="px-4 py-2 border-t border-gray-800">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-wrap gap-2 justify-center">
          {actions.map((item, index) => (
            <motion.button
              key={index}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => onActionClick(item.action)}
              className="flex items-center space-x-2 bg-gray-800 hover:bg-gray-700 border border-gray-700 rounded-full px-4 py-2 text-sm text-gray-300 hover:text-white transition-all duration-200"
            >
              <SafeIcon icon={item.icon} className="w-4 h-4" />
              <span>{item.label}</span>
            </motion.button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;